import React from "react";
import { Route, Routes } from "react-router-dom";
// internal
import BackToTop from "../components/BackToTop";
import AnimateMouse from "../components/common/AnimateMouse";
import ContextProvider from "../components/context/ContextProvider";
import Home from "../components/Home/Home";
import HomeThree from "../components/HomeThree/HomeThree";

const AppNavigation = () => {
  return (
    <ContextProvider>
      <AnimateMouse />
      <Routes>
        <Route path="/" element={<HomeThree />} />
        {/* <Route path="/home-2" element={<HomeTwo />} />
        <Route path="/home-3" element={<HomeThree />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/team-details" element={<TeamDetails />} />
        <Route path="/service" element={<Service />} />
        <Route path="/service-details" element={<ServiceDetails />} />
        <Route path="/price" element={<Price />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio-details" element={<PortfolioDetails />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-details" element={<BlogDetails />} /> */}
      </Routes>
      <BackToTop />
    </ContextProvider>
  );
};

export default AppNavigation;
